module.exports = __webpack_public_path__ + "static/media/IMG_0854.121e543a.jpg";